// extracted by mini-css-extract-plugin
export default {"container":"FooterButtons_container__nuFxF"};